import type { AtlasMission } from '../atlas.types';

export const commitmentMission: AtlasMission = {
  id: 'first-baseline',
  title: 'Record your first delivery baseline',
  description: 'Capture a scope-and-delivery snapshot so you can compare later.',
  kicker: 'Guided tour',
  estimatedMinutes: 2,
  entryRoute: '/commitment',
  featureKey: 'atlas.firstBaseline',
  storage: 'atlas',
  steps: [
    {
      id: 'intro',
      title: 'What is a commitment?',
      body: 'A commitment captures what you promised to deliver (scope) and what actually got delivered (delivery). Baselines are the frozen snapshots you compare later.',
      anchorId: 'commitment-intro-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'create',
      title: 'Create a baseline',
      body: 'Use "Create Commitment" to snapshot the current product scope and current delivery. You can record a baseline at any point in the cycle — the earlier, the better.',
      anchorId: 'commitment-create-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'compare',
      title: 'Compare versions over time',
      body: 'Once you have two or more baselines, the Commitment page shows scope and delivery drift between them. That comparison is where the value shows up.',
      anchorId: 'commitment-compare-anchor',
      primaryLabel: 'Done',
    },
  ],
};
